import { STATUS, REQUEST_ACTIONS, STATIC_ACTIONS } from '../../Constants/Actions.constants';
import { INeoAction } from './../Actions.interface';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { convertStringObjectToEmptyErrorKeyValues } from '../../Helpers/Parsers.helper';

interface ErrorState {
  [x: string]: IErrorResponse | null;
}

export const INITIAL_STATE: ErrorState = convertStringObjectToEmptyErrorKeyValues(
  REQUEST_ACTIONS,
) as ErrorState;

export default (state = INITIAL_STATE, action: INeoAction) => {
  const { name, status, payload, type } = action;

  if (type === STATIC_ACTIONS.CLEAR_ERROR) {
    return { ...state, [payload]: null };
  }

  if (name) {
    switch (status) {
      case STATUS.LOADING: {
        return { ...state, [name]: null };
      }

      case STATUS.SUCCESS: {
        return { ...state, [name]: null };
      }

      case STATUS.FAILURE:
      case STATUS.UNAUTHORIZED: {
        return { ...state, [name]: payload as IErrorResponse };
      }

      default:
        return state;
    }
  }

  return state;
};
